export default __webpack_public_path__ + "static/media/Chili.e1d6ce3d.jpg";